import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, Mark, Xp } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { courses } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Course = () => {
  const { saved, markSaved } = useWeb();

  return (
    <>
      <div className="web-hero">
        <h2>Learn today, lead tomorrow</h2>
        <p>Build skills, get certified, and create your future.</p>
        <Icon name="bulb" className="float" />
      </div>
      <Chips group="learn" options={['All', 'Recommended', 'Popular', 'My Courses']} />
      <div className="web-grid two">
        {courses.map((course) => {
          const enrolled = Boolean(saved[course.id]);
          return (
            <article className="web-card web-row" key={course.id}>
              <Mark name={course.icon} from={course.from} to={course.to} />
              <div className="web-grow">
                <b>{course.title}</b>
                <div className="web-mut">{course.category} · {course.rating}</div>
                <span className="web-tag">Certificate</span>
                <div><Xp amount={100} /></div>
              </div>
              <button type="button" className={`web-btn${enrolled ? ' ok' : ''}`} onClick={() => markSaved(course.id, 'Enrolled')}>
                {enrolled ? 'Enrolled' : 'Enroll'}
              </button>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default Course;
